/* La charte d'Omnix Desk — le système, montré par lui-même.
 *
 * Pourquoi cette page vit DANS l'application plutôt que dans un document à
 * côté : un document se recopie, et une copie diverge. Ici, les pastilles
 * lisent les variables réelles au moment du rendu, les composants sont les
 * composants, et le style vient du même app.css que le reste. Si quelqu'un
 * change une couleur demain, cette page le dit le jour même ; une charte en
 * PDF, elle, aurait encore raison tout en ayant tort.
 *
 * Et elle ne se contente pas de montrer : elle mesure. Chaque paire de
 * couleurs qui porte du texte annonce son rapport de contraste. Une charte
 * qui ne se vérifie pas n'est qu'une affiche.
 */

import { useEffect, useState } from "react";
import { Fondations } from "./Fondations";
import { Composants } from "./Composants";
import { Pratiques } from "./Pratiques";

const PARTIES = [
  { cle: "fondations", nom: "Fondations" },
  { cle: "composants", nom: "Composants" },
  { cle: "pratiques", nom: "Pratiques" },
] as const;

type Partie = (typeof PARTIES)[number]["cle"];

export function Charte() {
  const [partie, setPartie] = useState<Partie>("fondations");

  /* Changer de partie remet la lecture en haut : on arrive sur un titre, pas
     au milieu d'un tableau de la partie précédente. */
  useEffect(() => {
    document.querySelector(".content")?.scrollTo({ top: 0 });
  }, [partie]);

  return (
    <div className="pad charte">
      <div className="charte-nav">
        {PARTIES.map((p) => (
          <button
            key={p.cle}
            type="button"
            className="pill"
            aria-pressed={partie === p.cle}
            onClick={() => setPartie(p.cle)}
          >
            {p.nom}
          </button>
        ))}
      </div>

      {partie === "fondations" ? <Fondations /> : null}
      {partie === "composants" ? <Composants /> : null}
      {partie === "pratiques" ? <Pratiques /> : null}
    </div>
  );
}
